import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, OperatorFunction } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { WebApiService } from 'src/app/shared';
import { ChargingStation } from '../charging-stations-section.model';
import { ChargingStationsStore } from '../state/charging-stations.state';

@Injectable({ providedIn: 'root' })
export class ChargingStationsService extends WebApiService {
  private chargingStationsUrl = `${environment.catalogApiUrl}/chargingstations`;

  constructor(protected http: HttpClient, protected snackBar: MatSnackBar, private store: ChargingStationsStore) {
    super(http, snackBar);
  }

  public getChargingStations(): Observable<ChargingStation[]> {
    return this.http.get<any[]>(`${this.chargingStationsUrl}`, { responseType: 'json' })
      .pipe(
        this.handleApiRequest(),
        this.mapChargingStations,
        this.updateStore(this.store));
  }

  private mapChargingStations(httpResponse$: Observable<any[]>): Observable<ChargingStation[]> {
    return httpResponse$.pipe(map(dtos => {
      return dtos.map(dto => {
        return {
          ...dto as ChargingStation,
          optionalFeatures: dto.optionalFeatures.map(dtoFeature => dtoFeature.optionalFeature),
          possibleElectricityMeterUnits: dto.possibleElectricityMeterUnits.map(dtoMeterUnit => dtoMeterUnit.electricityMeterUnit)};
        });
      }
    ));
  }

  private updateStore(store: ChargingStationsStore): OperatorFunction<ChargingStation[], ChargingStation[]> {
    return (source$: Observable<ChargingStation[]>): Observable<ChargingStation[]>  => {
      return source$.pipe(
        tap(chargingStations =>
          store.update(state => {
            state.chargingStations = [...chargingStations];
        }))
      );
    };
  }
}
